import styled from "styled-components";
export default styled.p`
  font-weight: ${({ big, small }) => (big ? "500" : small ? "300" : "400")};
  text-transform: capitalize;
  font-size: ${({ big, small }) => (big ? "1.05rem" : small ? "0.95rem" : "1rem")};
  margin: ${({ margin }) => margin || "1px"};
  padding: ${({ padding }) => padding || "5px"};
`;
